import { useEditor, EditorContent } from '@tiptap/react'
import StarterKit from '@tiptap/starter-kit'
import { Form } from 'react-bootstrap'
import { Bold, Italic, Strikethrough, Heading1, Heading2, List, ListOrdered, Quote } from 'lucide-react'

// Simple toolbar component
const MenuBar = ({ editor }) => {
    if (!editor) {
        return null
    }

    return (
        <div className="tiptap-toolbar d-flex flex-wrap gap-2 p-2 border-bottom">
            <button
                type="button"
                onClick={() => editor.chain().focus().toggleBold().run()}
                disabled={!editor.can().chain().focus().toggleBold().run()}
                className={`toolbar-btn ${editor.isActive('bold') ? 'is-active' : ''}`}
            >
                <Bold size={16} />
            </button>
            <button
                type="button"
                onClick={() => editor.chain().focus().toggleItalic().run()}
                disabled={!editor.can().chain().focus().toggleItalic().run()}
                className={`toolbar-btn ${editor.isActive('italic') ? 'is-active' : ''}`}
            >
                <Italic size={16} />
            </button>
            <button
                type="button"
                onClick={() => editor.chain().focus().toggleStrike().run()}
                disabled={!editor.can().chain().focus().toggleStrike().run()}
                className={`toolbar-btn ${editor.isActive('strike') ? 'is-active' : ''}`}
            >
                <Strikethrough size={16} />
            </button>
            <div className="vr mx-1"></div>
            <button
                type="button"
                onClick={() => editor.chain().focus().toggleHeading({ level: 1 }).run()}
                className={`toolbar-btn ${editor.isActive('heading', { level: 1 }) ? 'is-active' : ''}`}
            >
                <Heading1 size={16} />
            </button>
            <button
                type="button"
                onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()}
                className={`toolbar-btn ${editor.isActive('heading', { level: 2 }) ? 'is-active' : ''}`}
            >
                <Heading2 size={16} />
            </button>
            <button
                type="button"
                onClick={() => editor.chain().focus().toggleBulletList().run()}
                className={`toolbar-btn ${editor.isActive('bulletList') ? 'is-active' : ''}`}
            >
                <List size={16} />
            </button>
            <button
                type="button"
                onClick={() => editor.chain().focus().toggleOrderedList().run()}
                className={`toolbar-btn ${editor.isActive('orderedList') ? 'is-active' : ''}`}
            >
                <ListOrdered size={16} />
            </button>
            <button
                type="button"
                onClick={() => editor.chain().focus().toggleBlockquote().run()}
                className={`toolbar-btn ${editor.isActive('blockquote') ? 'is-active' : ''}`}
            >
                <Quote size={16} />
            </button>
        </div>
    )
}

export default function TextEditor({ label_name, mandatory, value, onChange, error }) {

    const editor = useEditor({
        extensions: [
            StarterKit,
        ],
        content: value, // Load initial content from Formik state
        onUpdate: ({ editor }) => {
            const html = editor.getHTML()
            // Call the parent's onChange with the HTML string
            onChange(html)
        },
    })

    return (
        <Form.Group className="mb-2">
            {label_name && (
                <Form.Label className={mandatory ? 'form_label_red' : 'form_label'}>
                    {`${label_name}${mandatory ? '*' : ''}`}
                </Form.Label>
            )}

            <div className={`tiptap-container border rounded ${error ? 'border-danger' : ''}`}>
                <MenuBar editor={editor} />
                <EditorContent editor={editor} className="tiptap-content p-2" style={{ minHeight: '150px' }} />
            </div>

            {error}
        </Form.Group>
    )
}